function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20.5,
  r: 20,
  fill: "#1F2937"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_92_5154)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6094 29.6143V9.52856H15.4379V29.6143H13.6094Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5615 29.6143V9.52856H26.3901V29.6143H24.5615Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.0413 15.2823C18.0004 16.5351 19.1307 17.1476 19.9999 17.1476C20.8655 17.1476 21.996 16.5296 22.9575 15.2693C23.8961 14.039 24.5618 12.3271 24.5618 10.4429H26.3903C26.3903 12.7491 25.5798 14.8467 24.4113 16.3784C23.2657 17.88 21.658 18.9762 19.9999 18.9762C18.3452 18.9762 16.7374 17.8935 15.5894 16.3939C14.4191 14.8653 13.6094 12.7669 13.6094 10.4429H15.4379C15.4379 12.3475 16.1044 14.0586 17.0413 15.2823Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3645 15.9445C13.1587 14.7558 13.6093 13.0439 13.6093 11.0714H15.4378C15.4378 13.2894 14.9361 15.387 13.885 16.9603C12.8131 18.5647 11.1734 19.6047 9.04736 19.6047V17.7762C10.4928 17.7762 11.5912 17.102 12.3645 15.9445Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.6506 15.9234C28.4305 17.0803 29.5303 17.7476 30.952 17.7476V19.5762C28.8499 19.5762 27.2116 18.5435 26.1344 16.9456C25.0766 15.3766 24.5615 13.2784 24.5615 11.0428H26.3901C26.3901 13.0263 26.8512 14.7377 27.6506 15.9234Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.9521 23.2238H9.04736V21.3953H30.9521V23.2238Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.0854 17.3953V22.3095H17.2568V17.3953H19.0854Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7426 17.3953V22.3095H20.9141V17.3953H22.7426Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.96191 22.3095V17.7476H11.7905V22.3095H9.96191Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.2095 22.3095V17.7476H30.038V22.3095H28.2095Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9807 29.6142H14.9712V27.7856H14.9807V29.6142Z",
  fill: "white"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_92_5154"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22.8571,
  height: 22.8571,
  fill: "white",
  transform: "translate(8.57129 9.07141)"
})));
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.92c6a1b1cc3ce312b0301209c95ee447.svg";
export { ForwardRef as ReactComponent };